// react
import React, { useEffect } from 'react';

// styled components
import { StyledObjectLight } from './StyledObjectLight';

// common
import SidebarContainer from 'common/SidebarContainer/SidebarContainer';


const ObjectLight = ({ modelList, refetchModelList, netStatus, modelListIsLoading, setIsAnimation, setIsObjectTag }) => {
    useEffect(() => {
        setIsAnimation(false);
        setIsObjectTag(false);
    }, []);
    return (
        <SidebarContainer
            modelList={modelList}
            refetchModelList={refetchModelList}
            modelListIsLoading={modelListIsLoading}
            netStatus={netStatus}
        >
            <StyledObjectLight className="flexCenter">
            </StyledObjectLight>
        </SidebarContainer>
    );
};

export default ObjectLight;
